import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { maxTimeBetweenReloads } from '../consts';
import { convertQueryParamsToString } from '../lib/convert-query-params-to-string';
import { getFullPath } from '../lib/get-full-path';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root',
})
export class AutoReloadGuard {
  constructor(private state: StateService, @Inject(PLATFORM_ID) private platformId: string) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    if (isPlatformServer(this.platformId)) return true;
    if (Date.now() - this.state.lastReloadTime > maxTimeBetweenReloads) {
      if (!window.onbeforeunload) {
        const path = getFullPath(next);
        const queryString = convertQueryParamsToString(next.queryParams);
        window.location.href = `${window.location.origin}/${path.join('/')}${queryString}${
          next.fragment ? `#${next.fragment}` : ''
        }`;
        return false;
      }
    }
    return true;
  }
}
